import { z } from "zod";
import {
  WhatsappMessageTemplateCategory,
  WhatsappMessageTemplateFormat,
} from "../../../../../../apps/web/src/lib/types/api/whatsapp.type";

export enum WhatsappMessageTemplateType {
  GREETING = "GREETING",
  HEADER = "HEADER",
  BODY = "BODY",
  FOOTER = "FOOTER",
  BUTTONS = "BUTTONS",
  CAROUSEL = "CAROUSEL",
  LIMITED_TIME_OFFER = "LIMITED_TIME_OFFER",
  CALL_PERMISSION_REQUEST = "CALL_PERMISSION_REQUEST",
}

export enum WhatsappMessageTemplateButtonType {
  QUICK_REPLY = "QUICK_REPLY",
  URL = "URL",
  VOICE_CALL = "VOICE_CALL",
  PHONE_NUMBER = "PHONE_NUMBER",
  COPY_CODE = "COPY_CODE",
  CATALOG = "CATALOG",
  FLOW = "FLOW",
}

export enum WhatsappParameterTypeEnum {
  TEXT = "text",
  IMAGE = "image",
  DOCUMENT = "document",
  VIDEO = "video",
  CURRENCY = "currency",
  DATE_TIME = "date_time",
  PAYLOAD = "payload",
  LOCATION = "location",
}

export const whatsappTemplateNodeSchema = z.object({
  nodeId: z.string().min(1, "Node id is required"),
  isValid: z.boolean(),
  payload: z.object({
    template: z.object({
      id: z.string().min(1, "Template Id is required"),
      name: z.string().min(1, "Please select valid template"),
      language: z.string(),
      status: z.string(),
      category: z.nativeEnum(WhatsappMessageTemplateCategory),
      components: z.array(
        z.object({
          type: z.nativeEnum(WhatsappMessageTemplateType),
          format: z.nativeEnum(WhatsappMessageTemplateFormat).optional(),
          text: z.string().optional(),
          buttons: z
            .array(
              z.object({
                type: z.nativeEnum(WhatsappMessageTemplateButtonType),
                text: z.string(),
                phone_number: z.string().optional(),
                url: z.string().optional(),
                payload: z.string().optional(),
                example: z.array(z.string()).optional(),
              }),
            )
            .optional(),
        }),
      ),
    }),
    content: z.object({
      id: z.string(),
      components: z.array(
        z.object({
          type: z.nativeEnum(WhatsappMessageTemplateType),
          subType: z.nativeEnum(WhatsappMessageTemplateButtonType).optional(),
          index: z.number().int().nonnegative().optional(),
          parameters: z
            .array(
              z.object({
                name: z.string().min(1, "Please enter a valid value"),
                type: z.nativeEnum(WhatsappParameterTypeEnum),
                attributeName: z.string().optional(),
                defaultValue: z.string().min(1, "Please enter a valid value"),
              }),
            )
            .optional(),
        }),
      ),
    }),
  }),
});
